import { BubbleFormPage } from '@go-client/components/BubbleUI/BubbleForm';
import { GroupBooking, GroupSubgroup, VenueRequestFile } from '@go-shared/types/groupBooking';
import { Property } from '@go-shared/types/property';
import React from 'react';
import {
  GroupBookingDataBundle,
  GroupBookingFormWorkflow,
  SubgroupForm,
  submitSubgroupForm,
} from '.';
import EnterSubgroupPage from '../EnterSubgroupPage';

interface EditSubgroupWorkflowPrereqs {
  selectedGroup: GroupBooking;
  selectedSubgroup: GroupSubgroup;
  subgroupForm: SubgroupForm;
  setSubgroupForm: React.Dispatch<React.SetStateAction<SubgroupForm>>;
  changeSubgroupFormAttribute: <T extends keyof SubgroupForm>(key: T, val: SubgroupForm[T]) => void;
  property: Property;
  handleSubgroupUploadFile: (file: File) => void;
  handleSubgroupUpdateFile: (file: VenueRequestFile) => void;
  handleSubgroupDeleteFile: (file: VenueRequestFile) => void;
  onClose?: () => void;
  onSubmitBooking?: () => void;
}

export default function buildEditSubgroupWorkflow(
  pages: Array<BubbleFormPage<GroupBookingDataBundle>>,
  preqs: EditSubgroupWorkflowPrereqs
): GroupBookingFormWorkflow {
  async function handleSubmitSubgroupForm() {
    await submitSubgroupForm({
      selectedGroup: preqs.selectedGroup,
      selectedSubgroup: preqs.selectedSubgroup,
      subgroupForm: preqs.subgroupForm,
    });

    if (preqs.onSubmitBooking) preqs.onSubmitBooking();
    if (preqs.onClose) preqs.onClose();
  }

  pages.push({
    key: 'subgroup-edit-page-1',
    render: () => (
      <EnterSubgroupPage
        subgroupForm={preqs.subgroupForm}
        changeSubgroupForm={preqs.changeSubgroupFormAttribute}
        onUpdateFile={preqs.handleSubgroupUpdateFile}
        onUploadFile={preqs.handleSubgroupUploadFile}
        onDeleteFile={preqs.handleSubgroupDeleteFile}
        onClose={preqs.onClose}
        onSubmitSubgroupDetails={handleSubmitSubgroupForm}
      />
    ),
  });

  return {};
}
